/**
 * 呼叫中心-黑名单校验
 */
import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 列表回显
export const blacklistConfApi = () =>
  request.post('/call/call_center_blacklist/blacklistConf', {}, jsonHeaderConfig)
// 校验该黑名单开关
export const setValidSwitchApi = (data: any) =>
  request.post('/call/call_center_blacklist/setValidSwitch', data, jsonHeaderConfig)
// 新增号码-检查sim是否存在
export const checkSimRepeatApi = (data: any) =>
  request.post('/call/call_center_blacklist/checkSimRepeat', data, jsonHeaderConfig)
// 新增号码-黑名单列表&线路列表回显
export const getAddSimDropDataApi = () =>
  request.post('/call/call_center_blacklist/getAddSimDropData', {}, jsonHeaderConfig)
// 新增号码
export const addSimNumsApi = (data: any) =>
  request.post('/call/call_center_blacklist/add/simNums', data, jsonHeaderConfig)
// 查看号码-列表回显
export const querySimNumsApi = (data: any) =>
  request.post('/call/call_center_blacklist/query/simNums', data, jsonHeaderConfig)
// 查看号码-编辑号码
export const updateSimInfoApi = (data: any) =>
  request.post('/call/call_center_blacklist/updateSimInfo', data, jsonHeaderConfig)
// 查看号码-删除&批量删除号码
export const deleteSimNumApi = (data: any) =>
  request.post('/call/call_center_blacklist/delete/simNum', data, jsonHeaderConfig)
// 导入号码-下载模版
export const downloadImportTemplateApi = '/call/call_center_blacklist/download/importTemplate'
// 导入号码
export const importSimNumApi = (data: any) =>
  request.upload({
    url: '/call/call_center_blacklist/import',
    data
  })
// 下载导入失败结果
export const downloadFailResultApi = '/call/call_center_blacklist/download/failResult'
// 根据线路id获取线路下配置的黑名单
export const getBlackOfTenantLineApi = (data: any) =>
  request.post('/call/call_center_blacklist/getBlackOfTenantLine', data)
